import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const CustomLoader = () => {
  return (
    <Grid container spacing={0} justifyContent={"center"} alignItems={"center"}>
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        direction={"column"}
      >
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
        <Typography variant="body1" color="initial">
          Loading...
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CustomLoader;
